import { ChainConfig } from "@silo/types";
import { satisfies } from "effect/Function";
import { TOKEN_ADDRESS } from "../token-address";

export const base = satisfies<ChainConfig>()({ tokens: {
    [TOKEN_ADDRESS.base.PT_LBTC_MAY_2025]: {
        name: "Lombard • Pendle",
        symbol: "PT-LBTC (29 May 2025)",
      },
} } as const);
